import moment from 'moment';
import { useContext } from 'react';
import { DashboardResultsContext } from '../../DashboardResults.context';

export default () => {
  const { currentDates, setCurrentDates } = useContext(DashboardResultsContext);

  const [day] = currentDates;

  return (
    <>
      <div
        className="dashboard__results-header-item"
        onClick={() => setCurrentDates([moment(day).subtract(1, 'day').toDate()])}>
        <span>{'<'}</span>
      </div>
      <div className="dashboard__results-header-item dashboard__results-header-item--active">
        <span>{moment(day).format('dddd DD MMMM YYYY')}</span>
      </div>
      <div
        className="dashboard__results-header-item"
        onClick={() => setCurrentDates([moment(day).add(1, 'day').toDate()])}>
        <span>{'>'}</span>
      </div>
    </>
  );
};
